export default "__VITE_ASSET__256574f7__"